/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderDeliveryType {
  'Homeowner/installation address' = 1,
  'Company/warehouse address' = 2,
}
